import { getMessages } from '../../../../../../store/constants';

export const QUALIFICATION_QUESTIONS_PHONE_PROMPT = getMessages().getText('qualification.questions.phone.prompt');
